import React from "react";
import styles from "./ActionButtons.module.css";

import ClearFix from "../ClearFix";

const ActionButtons = props => {

    const onSaveHandler = () => {
        if (!props.onSave) return;
        props.onSave();        
    }

    const onCancelHandler = () => {
        if (!props.onCancel) return;
        props.onCancel();
    }

    const onReloadHandler = () => {
        if (!props.onReload) return;
        props.onReload();
    }


    return (
        <div className={styles.buttonWrapper}>
            {props.onSave && <button className={props.disabled ? styles.disabled : styles.enabled} 
                onClick={onSaveHandler} 
                disabled={props.disabled || props.saveDisabled}>
                    Save
            </button>}
            {props.onCancel && <button className={props.disabled ? styles.disabled : styles.enabled} 
                onClick={onCancelHandler} 
                disabled={props.disabled}>
                    Cancel
            </button>}
            {props.showReload && <button className={styles.enabled} onClick={onReloadHandler}>Reload</button>}
            <ClearFix />
        </div>
    );

}

export default ActionButtons;